import React, { useState } from 'react';
import Layout from '../../components/Layout';
import DataTable from 'react-data-table-component';
import { toast } from 'react-toastify';
import { post } from '../../controllers/apiController';
import { useEffect } from 'react';

const EtiketEkle = () => {
    const [labelName, setLabelName] = useState("");
    const [labelBackgroundColor, setLabelBackgroundColor] = useState("000000");
    const [labelTextColor, setLabelTextColor] = useState("000000");

    useEffect(() => {
        document.title = "Etiket Ekle | LEVELUP CRM";
    }, []);

    const createLabel = async () => {
        const cleanBgColor = labelBackgroundColor.replace('#', '');
        const cleanTextColor = labelTextColor.replace('#', '');

        if (labelName === "" || cleanBgColor === "" || cleanTextColor === "") {
            toast.error('Lütfen tüm alanları doldurunuz');
            return;
        }

        try {
            const res = await post("labels/", {
                labelName: labelName,
                labelBgColor: cleanBgColor,
                labelTextColor: cleanTextColor
            });

            setLabelName("");
            setLabelBackgroundColor("000000");
            setLabelTextColor("000000");
    
            toast.success('Etiket başarıyla oluşturuldu');
        } catch (err) {
            toast.error("Etiket oluşturulurken bir hata oluştu!");
        }
    }

    return (
        <Layout>
            <main className="nxl-container">
                <div className="nxl-content">
                    <div className="page-header">
                        <div className="page-header-left d-flex align-items-center">
                            <div className="page-header-title">
                                <h5 className="m-b-10">LEVELUP CRM</h5>
                            </div>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><a href="./">Anasayfa</a></li>
                                <li className="breadcrumb-item"><a href="./labels">Etiketler</a></li>
                                <li className="breadcrumb-item">Oluştur</li>
                            </ul>
                        </div>
                    </div>
                    <div className="main-content">
                        <div className="row">
                            <div className="col-xxl-12 col-md-12">
                                <div className="card stretch stretch-full">
                                    <div className="card-body">
                                        <div class="mb-5 d-flex align-items-center justify-content-between">
                                            <h5 class="fw-bold mb-0 me-4">
                                                <span class="d-block mb-2">Etiket Bilgileri:</span>
                                            </h5>
                                        </div>
                                        <div className="row mb-4 align-items-center">
                                            <div className="col-lg-4">
                                                <label for="labelName" className="fw-semibold">Etiket Başlığı: </label>
                                            </div>
                                            <div className="col-lg-8">
                                                <div className="input-group">
                                                    <div className="input-group-text"><i className="feather-tag"></i></div>
                                                    <input type="text" className="form-control" id="labelName" placeholder="Etiket Başlığı" onChange={(e) => setLabelName(e.target.value)} value={labelName} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-4 align-items-center">
                                            <div className="col-lg-4">
                                                <label for="labelBackgroundColor" className="fw-semibold">Etiket Arka Plan Rengi: </label>
                                            </div>
                                            <div className="col-lg-8">
                                                <div className="input-group">
                                                    <div className="input-group-text"><i className="feather-layers"></i></div>
                                                    <input type="color" className="form-control form-control-color" id="labelBackgroundColor" onChange={(e) => setLabelBackgroundColor(e.target.value)} value={labelBackgroundColor} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-4 align-items-center">
                                            <div className="col-lg-4">
                                                <label for="labelTextColor" className="fw-semibold">Etiket Yazı Rengi: </label>
                                            </div>
                                            <div className="col-lg-8">
                                                <div className="input-group">
                                                    <div className="input-group-text"><i className="feather-underline"></i></div>
                                                    <input type="color" className="form-control form-control-color" id="labelTextColor" onChange={(e) => setLabelTextColor(e.target.value)} value={labelTextColor} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mt-3 d-flex justify-content-start">
                                            <button onClick={createLabel} className="btn btn-primary">
                                                <i className="feather-plus me-2"></i>
                                                <span>Etiket Oluştur</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </main>
        </Layout>
    );
};

export default EtiketEkle;
